import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyChatModule } from '@vendasta/galaxy/chat';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { PageComponent } from '../../common/page.component';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { ClipboardModule } from './../../common/clipboard/clipboard.module';
import { DeleteDialogComponent } from './identity-provider-config-page/delete-dialog.component';
import { IdentityProviderConfigPageComponent } from './identity-provider-config-page/identity-provider-config-page.component';
import { GalaxyPageModule } from '@vendasta/galaxy/page';

@NgModule({
  declarations: [IdentityProviderConfigPageComponent, DeleteDialogComponent],
  imports: [
    RouterModule.forChild([{ path: '', component: IdentityProviderConfigPageComponent }]),
    CommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    TranslateModule,
    MatIconModule,
    GalaxyChatModule,
    GalaxyBadgeModule,
    GalaxyFormFieldModule,
    GalaxyInfiniteScrollTriggerModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    PageComponent,
    GalaxyPageModule,
  ],
})
export class IdentityProviderConfigModule {}
